import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('filled', 'crop-16-9-filled', 'Crop169Filled', [["path",{"d":"M18 7a3 3 0 0 1 3 3v4a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-4a3 3 0 0 1 3 -3z"}]]);